import { useCallback, useEffect, useRef } from 'react';
import uuid from 'uuid-random';
import { useDispatch } from 'react-redux';

import { get } from 'js/utils/fetch.util';
import { setWebContentLoadings } from 'js/components/system/Page/store/buzz/actions';

export const useFetchWebContent = () => {
    const webContentId = useRef(uuid());
    const dispatch = useDispatch();

    const setWebContentLoading = useCallback((status) => {
        dispatch(setWebContentLoadings({ webContentId: webContentId.current, isLoading: status }));
    }, [dispatch]);

    const handlerFetch = useCallback((params) => {
        setWebContentLoading(true);

        return get(params);
    }, [setWebContentLoading]);

    const handlerOnResponse = useCallback((response) => {
        setWebContentLoading(false);

        return response;
    }, [setWebContentLoading]);

    const handlerOnError = useCallback((error) => {
        setWebContentLoading(false);

        return error;
    }, [setWebContentLoading]);

    useEffect(() => () => {
        setWebContentLoading(false);
    }, [setWebContentLoading]);

    return {
        handlerFetch,
        handlerOnError,
        handlerOnResponse
    };
};
